import { cardType } from "../../../types/game";
import style from "./BanicoinCard.module.css";
interface cardProp extends cardType {
  className?: string;
  result?: boolean;
  small?: boolean;
}

const BanicoinCard: React.FC<cardProp> = (card) => {
  return (
    <div className={`${style.card} ${card.className ? card.className : ""}`}>
      <div className={`${style.inner} `}>
        <div className={style.content}>
          {card.result && (
            <div className={style.title}>
              <img
                src={`${process.env.PUBLIC_URL}/assets/icon/mini-star-gold.svg`}
                alt=""
              />
              <span> بانی‌مد برات یه سورپرایز داره!</span>
            </div>
          )}
          <div className={style.banicoin}>
            <div className={style["banicoin-right"]}>
              <img
                src={`${process.env.PUBLIC_URL}/assets/icon/coin.svg`}
                alt="banicoin"
                className="mobile"
              />
              <span> {card.amount} بانی‌کوین</span>
            </div>
          </div>
          <img
            src={`${process.env.PUBLIC_URL}/assets/icon/coin.svg`}
            alt="banicoin"
            style={{ marginBottom: 16, width: 50, height: 50 }}
            className="desktop"
          />
          <div
            className={`${style["expire-wrapper"]} w-full`}
            style={{
              justifyContent: card.result ? "center" : "center",
            }}
          >
            <div className={style.expire}>
              {/* <img
                src={`${process.env.PUBLIC_URL}/assets/icon/expire.svg`}
                alt=""
              /> */}
              <span> مهلت استفاده: {card.expire_text}</span>
            </div>
          </div>
          <div className="flex justify-center items-center w-full mt-2">
            <a
              href={card.link}
              target="_blank"
              rel="noreferrer"
              className={`${style["banicoin-buy"]}`}
            >
              <span>بانی‌کلاب</span>
              {/* <img
                src={`${process.env.PUBLIC_URL}/assets/icon/arrow-left-dark.svg`}
                alt=""
              /> */}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BanicoinCard;
